require('./web/jquery.webslider');
var $ = require('jquery');
//export to window
window.$ = $;
window.jQuery = $;
require('bootstrap/collapse');
require('bootstrap/transition');
require('bootstrap/tab');
//shimované pluginy většinou nemají export, většinou extendují jQuery object
require('fg-frontend/ramjet/partialUpdate');
require('fg-frontend/ramjet/liveValidation');
var TargetBlankAutoTitle = require('fg-frontend/plugins/required/targetBlankAutoTitle');
var PhoneLinkActivation = require('fg-frontend/plugins/required/phoneLinkActivation');
require('fg-frontend/plugins/jquery.universal-pagination');
require('./web/highslide-settings');
require('./third/plUpload/fg.upload');
require('picturefill');
require('./web/jquery.social-share');
// require('./web/svg4everybody');
require('./web/slick');
var isMobile = require('./web/isMobile');

if (window.location.hash.indexOf('#collapse') != -1) {
  var collapse = window.location.hash.match(/collapse(\d)/)
  if (collapse[0]) {
    setTimeout(function () {
      $("html, body").animate({ scrollTop: $(`#${collapse[0]}`).offset().top - 50 }, 500);
    }, 1000)
  }
}
const svg4everybody = require('./web/svg4everybody');
svg4everybody();
// $(function () {
// 	svg4everybody();
// });
// var svg4e = require('./web/svg4everybody2');
// require('./web/svg4everybody');
//require('jquery-ui/datepicker');
//require('jquery-ui/i18n/datepicker-cs');
//require('fg-frontend/third/jquery-ui/datetimePicker/timepicker');
//require('fg-frontend/third/jquery-ui/datetimePicker/localization/timepicker-cs');


/**
 * Promění definovaný selektor (span.phone-number je default, z této definice je možné smazat) v odkazy s telefonním číslem.
 * Pouze na mobilních telefonech. Automaticky se mění i po přidání do DOMu. Pokud z nějakého důvodu nefunguje,
 * je možné pořešit pomocí phoneLink.getRelevantElements()
 */
var phoneLink = new PhoneLinkActivation(document.body, {
  selector: 'span.phone-number',		// vymezit selektor, kde chceme použít transformaci čísla na odkaz
  linkClassName: 'phone-number',		// třída, která bude vložena na výsledný odkaz (kvůli případnému stylování)
  domChange: true						// flag, zda chceme měnit čísla on the fly i po změně DOMu.
  // Pokud ne, phoneLink.getRelevantElements()
});
// window.phoneLink = phoneLink;		// toto není nutné zapínat, pokud nepotřebujeme manuálně volat změnu

/**
 * Pokud máte na stránce anchor s target="blank" atributem, který nemá vyplněný title, nasadí se na něj
 * automaticky titulek ve smyslu "Otevře se v novém okně" dle langu stránky (atribut html lang).
 * Texty jsou definované ve třídě TargetBlankAutoTitle. Lze je definovat ručně při incicalizaci
 * např:  $("body").targetBlankAutoTitle({labels: {cs: "Lorem ipsum", sk: "Dolor sit"}});
 *
 * Pro weby mimo standardní kolekci jazyků (en, de, sk, cz) doporučuji překlad korekturovat.
 * Byl pouze automaticky přeložen.
 *
 * Korekturované překlady můžete dávat do issue https://ep.fg.cz/issues/60227
 *
 * Zkratky jazyků jsou z ISO 639-1 normy
 */
window.targetBlankAutoTitle = new TargetBlankAutoTitle();

/*
 inicializace funkcí
 ==================================================*/

if (isMobile.phone || isMobile.tablet) {
  $('body').addClass('touch-device');
} else {
  $('body').addClass('desktop');
};


$(function () {

  // Taby
  $('.tabs-navigation li a').click(function (e) {
    e.preventDefault();
    $(this).tab('show');
  })

  // Menu
  $('.js_menu-open').click(function (e) {
    e.preventDefault();
    $('#collapseMenu').addClass('in');
  });
  $('.js_menu-close').click(function (e) {
    e.preventDefault();
    $('#collapseMenu').removeClass('in');
  });

  // Social share
  $('a[data-social-network]').socialShare();

  // // Ovladani menu
  // $('.desktop .js_has-submenu').hover(function () {
  // 	var t = $(this);
  // 	var target = t.data('submenu');

  // 	$('.js_has-submenu').removeClass('has-submenu');
  // 	$('.wrapper-submenu').addClass('hidden');

  // 	t.addClass('has-submenu');
  // 	$('#' + target).removeClass('hidden');

  // }, function () {
  // 	var $el = $(this);
  // 	var target = $el.data('submenu');
  // 	var $submenuNavigation = $('#' + target);

  // 	var currentMousePosX = 0,
  // 		currentMousePosY = 0,
  // 		leftOffset = $submenuNavigation.offset().left,
  // 		topOffset = $submenuNavigation.offset().top,
  // 		rightOffset = leftOffset + $submenuNavigation.width(),
  // 		bottomOffset = topOffset + $submenuNavigation.height(),
  // 		leftOffsetThis = $(this).offset().left,
  // 		topOffsetThis = $(this).offset().top,
  // 		rightOffsetThis = leftOffsetThis + $(this).width(),
  // 		bottomOffsetThis = topOffsetThis + $(this).innerHeight();

  // 	$submenuNavigation.hover(function() {}, function() {
  // 		var t = $(this);
  // 		t.addClass('hidden');
  // 		$el.removeClass('has-submenu');
  // 	});

  // 	$(document).on('mousemove.menuEvent', function (event) {
  // 		currentMousePosX = event.clientX;
  // 		currentMousePosY = event.clientY;

  // 		if (currentMousePosX > 20 && currentMousePosY > 20) { // IE Edge FIX
  // 			if ((currentMousePosX < leftOffset || currentMousePosX > rightOffset || currentMousePosY < topOffset || currentMousePosY > bottomOffset) && (currentMousePosX < leftOffsetThis || currentMousePosX > rightOffsetThis || currentMousePosY < topOffsetThis || currentMousePosY > bottomOffsetThis)) {
  // 				$el.removeClass('has-submenu');
  // 				$submenuNavigation.addClass('hidden');
  // 				$(this).unbind(".menuEvent");
  // 			}
  // 		}
  // 	});
  // });



  // Carousel SLICK
  if ($('.slick-slider').length) {
    $('.slick-slider').slick({
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      centerMode: true,
      variableWidth: true
    });
  }

  $('#myTabs a').click(function (e) {
    e.preventDefault()
    $(this).tab('show')
  })

  // Disable scroll zooming and bind back the click event
  if (isMobile.phone || isMobile.tablet) {
    if ($('.js_gm .google-map').length) {
      $('.js_gm .google-map').css("pointer-events", "none");
    }
    ;

    var onMapMouseleaveHandler = function (event) {
      var that = $(this);

      that.on('click', onMapClickHandler);
      that.off('mouseleave', onMapMouseleaveHandler);
      that.find('.google-map').css("pointer-events", "none");
    }

    var onMapClickHandler = function (event) {
      var that = $(this);

      // Disable the click handler until the user leaves the map area
      that.off('click', onMapClickHandler);

      // Enable scrolling zoom
      that.find('.google-map').css("pointer-events", "auto");

      // Handle the mouse leave event
      that.on('mouseleave', onMapMouseleaveHandler);
    }

    // Enable map zooming with mouse scroll when the user clicks the map
    $('.js_gm').on('click', onMapClickHandler);
  }

  // Accordeon
  $('.panel-control').click(function() {
    if ($(this).attr('data-img')) {
      $('.product-info .panel-motive').attr('src',$(this).data('img'));
    }
  });
});

// Rozbalovani accordionu podle kotvy z URL
$(function () {
  var id = location.hash.substr(1);
  if (id) {
    var $selector = $("#" + id);
    if ($selector.length != 0) {
      $selector.collapse('show');
      $('html, body').animate({
        scrollTop: $selector.offset().top - 55
      }, 500);
    }
  }
}());

$(window).on('load',function(){
  svg4everybody();
});

//Header - oetvírání menu, megamenu a vyhledávání
const header = document.querySelector('.js_header');
const menuCloseButtons = document.querySelectorAll('.js_header-menu-close');
const hamburger = document.querySelector('.js_header-hamburger');
const searchTrigger = document.querySelector('.js_search-trigger');
const searchClose = document.querySelector('.js_search-close');
const searchInput = document.querySelector('.js_header__search-input');
const searchOverlay = document.querySelector('.js_search-overlay');
const searchForm = searchInput ? searchInput.closest('form') : null;
const navItems = document.querySelectorAll('.js__nav-item');
const megamenus = document.querySelectorAll('.js_megamenu');
const megamenuTriggers = document.querySelectorAll('.js_megamenu-trigger');

// Remove megamenu markup from nav items that have no submenu links
navItems.forEach(function (navItem) {
  if (navItem.classList.contains('header__nav-item--has-megamenu')) {
    var list = navItem.querySelector('.js_megamenu-list');
    if (!list || list.querySelectorAll('.header__megamenu-link').length === 0) {
      navItem.classList.remove('header__nav-item--has-megamenu');
      var megamenu = navItem.querySelector('.js_megamenu');
      if (megamenu) megamenu.remove();
      var trigger = navItem.querySelector('.js_megamenu-trigger');
      if (trigger) trigger.remove();
    }
  }
});

// Apply column classes based on item count (6+ = 2 cols, 12+ = 3 cols)
document.querySelectorAll('.js_megamenu-list').forEach(function (list) {
  var count = list.querySelectorAll('.header__megamenu-item').length;
  if (count >= 12) {
    list.classList.add('header__megamenu-list--3cols');
  } else if (count >= 6) {
    list.classList.add('header__megamenu-list--2cols');
  }
});

// Re-query after cleanup
const megamenusClean = document.querySelectorAll('.js_megamenu');
const megamenuTriggersClean = document.querySelectorAll('.js_megamenu-trigger');

hamburger.addEventListener('click', toggleMenu);
for (let i = 0; i < menuCloseButtons.length; i++) {
  menuCloseButtons[i].addEventListener('click', closeMenu);
}
if (searchTrigger) searchTrigger.addEventListener('click', openSearch);
if (searchClose) searchClose.addEventListener('click', closeSearch);
if (searchOverlay) searchOverlay.addEventListener('click', closeSearch);

// Do not submit an empty query — the results page would have nothing to search for
if (searchForm) {
  searchForm.addEventListener('submit', function (e) {
    if (!searchInput.value.trim()) {
      e.preventDefault();
      searchInput.focus();
    }
  });
}

document.addEventListener('keydown', function (e) {
  const escPressed = e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
  if (escPressed && header.classList.contains('header--search-opened')) {
    closeSearch();
  }
});

for (let i = 0; i < megamenuTriggersClean.length; i++) {
  megamenuTriggersClean[i].addEventListener('click', toggleMegamenu);
}

function toggleMenu() {
  if (header.classList.contains('header--menu-opened')) {
    closeMenu();
  } else {
    openMenu();
  }
}

function openMenu() {
  header.classList.add('header--menu-opened');
  document.body.classList.add('overflow-hidden');
  if (hamburger) hamburger.setAttribute('aria-expanded', 'true');
}

function closeMenu() {
  header.classList.remove('header--menu-opened');
  document.body.classList.remove('overflow-hidden');
  if (hamburger) hamburger.setAttribute('aria-expanded', 'false');
}

function openSearch() {
  header.classList.add('header--search-opened');
  // Compensate the hidden scrollbar so the page does not jump sideways
  const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
  if (scrollbarWidth > 0) document.body.style.paddingRight = `${scrollbarWidth}px`;
  document.body.classList.add('overflow-hidden');
  if (searchTrigger) searchTrigger.setAttribute('aria-expanded', 'true');
  if (searchInput) searchInput.focus();
}

function closeSearch() {
  header.classList.remove('header--search-opened');
  document.body.classList.remove('overflow-hidden');
  document.body.style.paddingRight = '';
  if (searchTrigger) {
    searchTrigger.setAttribute('aria-expanded', 'false');
    searchTrigger.focus();
  }
}

function toggleMegamenu(e) {
  const trigger = e.currentTarget;
  const navItem = trigger.closest('.js__nav-item');
  const megamenu = navItem.querySelector('.js_megamenu');
  const megamenuList = navItem.querySelector('.js_megamenu-list');
  if (navItem.classList.contains('header__nav-item--megamenu-opened')) {
    megamenu.style.height = '0px';
    navItem.classList.remove('header__nav-item--megamenu-opened');
    trigger.setAttribute('aria-expanded', 'false');
  } else {
    for (let i = 0; i < megamenusClean.length; i++) {
      megamenusClean[i].style.height = '0px';
    }
    for (let i = 0; i < navItems.length; i++) {
      navItems[i].classList.remove('header__nav-item--megamenu-opened');
      var otherTrigger = navItems[i].querySelector('.js_megamenu-trigger');
      if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
    }
    megamenu.style.height = `${megamenuList.offsetHeight}px`;
    navItem.classList.add('header__nav-item--megamenu-opened');
    trigger.setAttribute('aria-expanded', 'true');
  }
}

// Video modal
var videoModal = document.querySelector('.js_videoModal');
var videoIframe = document.querySelector('.js_videoModalIframe');
var videoPlayer = document.querySelector('.js_videoModalPlayer');
var videoPlayBtns = document.querySelectorAll('.js_videoPlay');
var videoCloseBtns = document.querySelectorAll('.js_videoModalClose');

function isMp4Url(url) {
  return url && /\.mp4(\?|$)/i.test(url);
}

function openVideoModal(url) {
  if (!url || !videoModal) return;
  if (isMp4Url(url) && videoPlayer) {
    if (videoIframe) videoIframe.style.display = 'none';
    videoPlayer.style.display = 'block';
    videoPlayer.src = url;
    videoPlayer.play();
  } else if (videoIframe) {
    if (videoPlayer) videoPlayer.style.display = 'none';
    videoIframe.style.display = 'block';
    videoIframe.src = url + (url.indexOf('?') === -1 ? '?' : '&') + 'autoplay=1';
  }
  videoModal.classList.add('videoModal--open');
  videoModal.setAttribute('aria-hidden', 'false');
  document.body.classList.add('overflow-hidden');
  // Focus the close button for keyboard users
  var closeBtn = videoModal.querySelector('.videoModal__close');
  if (closeBtn) closeBtn.focus();
}

function closeVideoModal() {
  if (!videoModal) return;
  videoModal.classList.remove('videoModal--open');
  videoModal.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('overflow-hidden');
  if (videoIframe) {
    videoIframe.src = '';
    videoIframe.style.display = 'block';
  }
  if (videoPlayer) {
    videoPlayer.pause();
    videoPlayer.src = '';
    videoPlayer.style.display = 'none';
  }
}

for (var i = 0; i < videoPlayBtns.length; i++) {
  videoPlayBtns[i].addEventListener('click', function () {
    openVideoModal(this.getAttribute('data-video-url'));
  });
}

for (var i = 0; i < videoCloseBtns.length; i++) {
  videoCloseBtns[i].addEventListener('click', function () {
    closeVideoModal();
  });
}

document.addEventListener('keydown', function (e) {
  if (e.key === 'Escape' && videoModal.classList.contains('videoModal--open')) {
    closeVideoModal();
  }
});

// Highlight Cards Swiper
var Swiper = require('swiper/swiper-bundle');

(function initHighlightCardsSwiper() {
  var section = document.querySelector('.highlightCards--carousel');
  if (!section) return;

  var swiperEl = section.querySelector('.js_highlightCardsSwiper');
  if (!swiperEl) return;

  var slides = swiperEl.querySelectorAll('.swiper-slide');
  if (slides.length < 3) return;

  var prevBtn = section.querySelector('.js_highlightCardsPrev');
  var nextBtn = section.querySelector('.js_highlightCardsNext');
  var paginationEl = section.querySelector('.js_highlightCardsPagination');

  new Swiper(swiperEl, {
    slidesPerView: 'auto',
    centeredSlides: true,
    spaceBetween: 16,
    loop: true,
    pagination: {
	  el: paginationEl,
	  clickable: true
    },
    navigation: {
	  nextEl: nextBtn,
	  prevEl: prevBtn
    },
    breakpoints: {
	  768: {
        spaceBetween: 24
	  }
    }
  });
})();

/*
 * !!!NECHAT NA KONCI web.js!!!
 * V hlavičce webu je JavaScript var q = []; $ = function(f) {q.push(f)};, který zajistí,
 * že kdekoli vyskytující se inline javascript bude vykonán až po načtení stránky
 * Inline JavaScript musí být vnořen do následujícího kusu kódu
 *
 * $(function(){
 *     //inline JavaScript
 * });
 *
 * který je ve skutečnosti zkrácené volání $(document).ready() @see http://learn.jquery.com/using-jquery-core/document-ready/
 * předpokládá se tedy, že na webu bude použito jQuery
 *
 * viz http://www.slideshare.net/slideshow/embed_code/17116700?startSlide=10
 * */
$.each(q, function (index, f) {
  $(f);
});




// WEBPACK FOOTER //
// ./config/module-publish/resources/js/web.js